import React, { useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { OtcThemeProvider } from '@otcmarketsgroup/otcm-ui-lib';
import { AuthProvider } from './context/Auth.context';
import Layout from './components/Layout';
import MarketReports from './container/MarketReports';
import { ROUTES } from './constants/routes';

const App = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const handler = (e) => {
            const newPath = e.detail.path.startsWith('/market-data') ? e.detail.path : `/market-data${e.detail.path}`;
            navigate(newPath, { replace: true });
        };

        window.addEventListener('parent:navigate', handler);
        return () => window.removeEventListener('parent:navigate', handler);
    }, [navigate]);

    return (
        <OtcThemeProvider>
            <AuthProvider>
                <Layout>
                    <Routes>
                        <Route path={ROUTES.marketReport} element={<MarketReports />} />
                    </Routes>
                </Layout>
            </AuthProvider>
        </OtcThemeProvider>
    );
};

export default App;
